<template>
  <div>
    <!-- 评价预警-创建任务组件 -->
    <el-drawer :visible.sync="drawer" direction="rtl" :with-header="false" :before-close="handleClose">
      <div class="createTpl">
        <!-- 抽屉头部 -->
        <header class="head">
          <span>创建任务</span>
          <i class="el-icon-close close" @click="handleClose()"></i>
        </header>

        <!-- 表单内容 -->
        <section class="createTplMain">
          <el-form ref="formSearch" :model="form" label-width="110px">
            <el-form-item label="任务名称：">
              <div class="sendMobile">
                <el-input placeholder="多个号码请用“,”隔开" v-model="form.taskName" style="width: 280px;"> </el-input>
              </div>
            </el-form-item>

            <el-form-item label="任务时间：">
              <div class="taskTime">
                <el-radio-group v-model="form.persistentOpenFlag">
                  <el-radio :label="1">持续开启</el-radio>
                  <el-radio :label="0">指定时间</el-radio>
                </el-radio-group>
                <div class="my_select_time" style="marginLeft: 6px;">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.taskAllowRunStartTime"
                    type="datetime"
                    placeholder="开始日期"
                    size="small"
                    :disabled="taskTimeDisabled"
                    :picker-options="pickerOptionsStart"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 120px;font-size:12px"
                    class="time1"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <div class="time_to_text" :class="{ to_text_disabled: taskTimeDisabled }">
                    至
                  </div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.taskAllowRunEndTime"
                    type="datetime"
                    :disabled="taskTimeDisabled"
                    :picker-options="pickerOptionsEnd"
                    placeholder="结束日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px;font-size:12px"
                    class="time2"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <i class="el-icon-circle-close date_icon1" @click="clearTaskTime()"></i>
                  <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="接收号码：">
              <div class="sendMobile">
                <!-- <el-input placeholder="多个号码请用“,”隔开" v-model="form.mobile" @change="sendMobileChange" style="width: 280px;"> </el-input> -->
                <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                          <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <button class="sendSmsTest" @click.prevent="sendSmsTest">
                  发送短信测试
                </button>
                <button class="smsRecord" @click.prevent="smsDialogs = true">
                  短信记录
                </button>
                <button class="smsRecord" style="margin-left: 4px;width: auto;" @click.prevent="showchangetestphone = true">
                  修改测试手机号
                </button>
              </div>
            </el-form-item>
            <!-- 评价预警的退款条件 -->
            <el-form-item label="发送条件：">
              <div class="sendMobile">
                评价少于或等于
                <el-select v-model="form.score" style="margin-left: 12px;">
                  <el-option v-for="item in sendCondition" :key="item.id" :label="item.label" :value="item.id"> </el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="选择商品：">
              <el-radio-group v-model="form.itemFilterType" @change="selectGoodsChangeRaido($event)">
                <el-radio :label="1">全部商品</el-radio>
                <el-radio :label="3">
                  指定商品
                  <button
                    v-if="form.itemFilterType == 3"
                    class="selectBtn marleft"
                    :class="{ disabled: form.itemFilterType != 3 }"
                    @click.prevent="selectGoodsChange(3)"
                  >
                    已选择
                    {{ goodsStateLength }}
                    个商品
                  </button>
                </el-radio>
                <el-radio :label="2">
                  排除商品
                  <button
                    v-if="form.itemFilterType == 2"
                    class="selectBtn marleft"
                    :class="{ disabled: form.itemFilterType != 2 }"
                    @click.prevent="selectGoodsChange(2)"
                  >
                    已选择
                    {{ goodsStateLength }}
                    个商品
                  </button>
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="通知时间：">
              <div style="display:flex; align-items: center;">
                <el-time-picker
                  class="timeChangeselect"
                  v-model="form.startSendtimeConfig"
                  value-format="HH:mm"
                  format="HH:mm"
                  placeholder="选择时间"
                >
                </el-time-picker>
                &nbsp; ~ &nbsp;
                <el-time-picker
                  class="timeChangeselect"
                  v-model="form.endSendtimeConfig"
                  value-format="HH:mm"
                  format="HH:mm"
                  placeholder="选择时间"
                  @change="pickerOptions1"
                >
                </el-time-picker>
              </div>
            </el-form-item>

            <el-form-item label="短信内容：">
              <el-input type="textarea" disabled placeholder="请输入短信内容" v-model="form.content" rows="4" style="width: 622px;"> </el-input>
            </el-form-item>
          </el-form>
        </section>

        <!-- 底部按钮 -->
        <footer class="footBtn">
          <button class="keepOpenBtn" v-if="disBtn1"><i class="el-icon-loading"></i>保存并开启</button>
          <button class="keepOpenBtn" v-else @click="keepOpen(true)">
            保存并开启
          </button>
          <button class="keepBtn" v-if="disBtn2"><i class="el-icon-loading"></i>保存设置</button>
          <button class="keepBtn" v-else @click="keepOpen(false)">保存设置</button>
        </footer>
      </div>
    </el-drawer>

    <!-- 商品选择组件 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      v-show="selectGoodsState"
      :moduleType="true"
      :isShow="selectGoodsState"
      :skuSearch="venderType"
      :selectGoods="selectGoodsArr"
      :selectGoodsSkuList="selectGoodsSkuList"
      :GoodsSkuIsflay="true"
      @close="selectGoodsClose"
    ></selectGoodsMonitor>

    <!-- 发送确认 -->
    <my-popup v-if="sendSmsTestState" :flag="sendSmsTestState" title="发送确认" @close="closeSend" width="500">
      <div class="sendSmsTestWrap">
        <p class="detailsInfo">
          <span>提交号码为 {{ form.mobile.split(",").length }}</span>
          当前短信字数为 {{ form.content.length }} 字，每条短信以
          {{ Math.ceil(form.content.length > 70 ? form.content.length / 67 : form.content.length / 70) }}
          条计费，
          <span
            >提交
            {{ form.mobile.split(",").length * Math.ceil(form.content.length > 70 ? form.content.length / 67 : form.content.length / 70) }}
            条短信，以实际发送条数为准！</span
          >
        </p>
        <el-button v-if="disSendBtn" type="primary"><i class="el-icon-loading"></i>发送</el-button>
        <el-button v-else type="primary" @click="handleSendConfirm">发送</el-button>
        <el-button @click="sendSmsTestState = false">取消</el-button>
      </div>
    </my-popup>

    <smsTemplates v-if="smsDialogs" :smsDialog="smsDialogs" @transferName="smsDialogs = false"></smsTemplates>
            
    <changetestphone :textPhoneId="textPhoneId" :nowtestMobiles="nowtestMobiles" v-if="showchangetestphone" @close="showchangetestphone = false" @mobilPhoneSubmit="mobilPhoneSubmit"></changetestphone>
  </div>
</template>

<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import myPopup from "@/components/myPopup";
import { postTask } from "@/api/serviceCenter/commentWarning";
import { preCommit,NewPreCommit, platformSend,getValidSmsTestMobiles } from "@/api/smsSend";
import smsTemplates from "@/components/sms-templates-x";
import changetestphone from "@/components/changetestphone.vue";
export default {
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
    createTime: {
      type: String,
      default: '',
    },
  },
  components: {
    selectGoodsMonitor,
    myPopup,
    smsTemplates,
    changetestphone
  },
  watch: {
    drawer(newVal) {
      if (!newVal) return;
      if (this.editData) {
        // 有值代表是编辑操作
        this.form = this.editData;
        // this.form.goodsList = this.editData.popCommentItemwaringList;
        // let arrList = this.editData.popCommentItemwaringList.map((i) => {
        //   return {
        //     ...i,
        //     wareTitle: i.itemTitle || i.title,
        //     logo: i.images || i.logo,
        //     isAdd: true,
        //     wareId: Number(i.wareId),
        //   };
        // });
        let arrList = [];
        console.log()
        if (!this.venderType) {
          console.log('!this.venderType:',this.venderType)
          arrList = this.editData.popCommentItemwaringList.wareList.map((i) => {
            return {
              ...i,
              wareTitle: i.itemTitle || i.title || i.goodTxt,
              logo: i.images || i.logo || i.imgSrc,
              isAdd: true,
              wareId: Number(i.wareId),
              skuId: i.skuId || "",
              skuList: i.skuId
                ? i.skuId.split(",").map((ele) => {
                    return { skuId: ele };
                  })
                : [],
            };
          });
          this.selectGoodsSkuList = this.editData.popCommentItemwaringList.skuList.map((i) => {
            return {
              ...i,
              wareTitle: i.itemTitle || i.title || i.goodTxt,
              logo: i.images || i.logo || i.imgSrc,
              isAdd: true,
              // wareId: Number(i.wareId),
              skuId: i.skuId,
            };
          });
          let skuArr = this.editData.popCommentItemwaringList.wareList
            .map((i) => i.skuId)
            .join(",")
            .split(",");
          let skuArr1 = this.editData.popCommentItemwaringList.skuList.map((i) => i.skuId);
          this.goodsStateLength = this.unique(skuArr1, skuArr).length;
        }
        if (this.venderType) {
          console.log('this.venderType:',this.venderType)
          arrList = this.editData.popCommentItemwaringList.skuList.map((i) => {
            return {
              ...i,
              wareTitle: i.itemTitle || i.title || i.goodTxt,
              logo: i.images || i.logo || i.imgSrc,
              isAdd: true,
              // wareId: Number(i.wareId),
              skuId: i.skuId,
            };
          });
          this.goodsStateLength = this.editData.popCommentItemwaringList.skuList.length;
        }
        this.form.goodsList = [...arrList, ...this.selectGoodsSkuList];
        this.selectGoodsArr = arrList;
        if (this.editData.itemFilterType == 3) {
          this.returnSelectGoodsAppoint = arrList;
        } else if (this.editData.itemFilterType == 2) {
          this.returnSelectGoodsExclude = arrList;
        }
      } else {
        this.form = {
          itemFilterType: 1,
          taskAllowRunStartTime: null,
          taskAllowRunEndTime: null,
          startSendtimeConfig: null,
          endSendtimeConfig: null,

          goodsList: [],
          score: 3,
          mobile: null,
          persistentOpenFlag: 1,
          taskName: "评价预警" + " " + this.createTime,
          content: "#买家昵称#给您" + this.shopTitle + "一个#评价星级#星评价，sku_id：#SKU_id#" + this.tipT,

          sort: 1,
          isOpen: 0,
        };
        this.selectGoodsSkuList = [];
        this.returnSelectGoodsAppoint = [];
        this.returnSelectGoodsExclude = [];
        this.selectGoodsArr = [];
      }
    },
    shopTitle(nVal) {
      if (!this.editData && nVal) {
        this.form.content = "#买家昵称#给您" + nVal + "一个#评价星级#星评价，sku_id：#SKU_id#" + this.tipT;
      }
    },
  },
  computed: {
    // 任务时间日期选择器是否禁用
    taskTimeDisabled() {
      return this.form.persistentOpenFlag == 1 ? true : false;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    shopTitle() {
      return this.$store.getters.loginUserInfo.shopTitle;
    },
  },
  data() {
    return {
      textPhoneId:"",
      nowtestMobiles:"",
      showchangetestphone:false,
      testOptions: [], // 获取测试手机号
      Selectmobiles:[],

      goodsStateLength: 0,
      selectGoodsSkuList: [],
      form: {
        itemFilterType: 1,
        taskAllowRunStartTime: null,
        taskAllowRunEndTime: null,
        startSendtimeConfig: null,
        endSendtimeConfig: null,
        goodsList: [],
        score: 1,
        mobile: null,
        persistentOpenFlag: 1,
        taskName: "评价预警" + " " + this.createTime,
        content: "",
        sort: 1,
        isOpen: 0,
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.form.taskAllowRunEndTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.taskAllowRunStartTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      // pickerOptionsEnd1: {
      //   disabledDate: (time) => {
      //     let beginDateVal = this.form.startSendtimeConfig;
      //     if (beginDateVal) {
      //       return time.getTime() < new Date(beginDateVal).getTime();
      //     }
      //   },
      // },
      sendCondition: [
        { label: "一星", id: 1 },
        { label: "二星", id: 2 },
        { label: "三星", id: 3 },
        { label: "四星", id: 4 },
        { label: "五星", id: 5 },
      ],
      disBtn1: false,
      disBtn2: false,
      disSendBtn: false,
      // 选择商品状态控制
      selectGoodsState: false,
      selectGoodsArr: [],
      sendSmsTestState: false,
      smsDialogs: false,
      returnSelectGoodsAppoint: [], //指定商品
      returnSelectGoodsExclude: [], //排除商品
      tipT: "拒收请回复R",
    };
  },
  mounted() {
    this.getValidSmsTestMobiles()
    console.log("this.shopTitle", this.shopTitle);
    if (this.editData) this.editInfo();
    this.form.content = "#买家昵称#给您" + this.shopTitle + "一个#评价星级#星评价，sku_id：#SKU_id#" + this.tipT;
  },
  methods: {
    mobilPhoneSubmit(val){
      this.getValidSmsTestMobiles()
      this.showchangetestphone = false
    },
    getValidSmsTestMobiles() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
          this.Selectmobiles = [];
          this.testOptions = res.data.smsTestMobiles
          this.nowtestMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    // 短信测试手机号 
    selectTestMobiles(val) {
      this.form.mobile = this.Selectmobiles.join(',')
    },
    /**
     * 保存并开启 || 保存设置
     */
    editInfo() {
      if (this.editData) {
        // 有值代表是编辑操作
        this.form = this.editData;
        let arrList = [];
        console.log("this.venderType",this.venderType)
        if (!this.venderType) {
          arrList = this.editData.popCommentItemwaringList.wareList.map((i) => {
            return {
              ...i,
              wareTitle: i.itemTitle || i.title || i.goodTxt,
              logo: i.images || i.logo || i.imgSrc,
              isAdd: true,
              wareId: Number(i.wareId),
              skuId: i.skuId || "",
              skuList: i.skuId
                ? i.skuId.split(",").map((ele) => {
                    return { skuId: ele };
                  })
                : [],
            };
          });
          this.selectGoodsSkuList  = this.editData.popCommentItemwaringList.skuList
          // this.selectGoodsSkuList = this.editData.popCommentItemwaringList.skuList.map((i) => {
          //   return {
          //     ...i,
          //     wareTitle: i.itemTitle || i.title || i.goodTxt,
          //     logo: i.images || i.logo || i.imgSrc,
          //     isAdd: true,
          //     // wareId: Number(i.wareId),
          //     skuId: i.skuId,
          //   };
          // });
          // let skuArr = this.editData.popCommentItemwaringList.wareList
          //   .map((i) => i.skuId)
          //   .join(",")
          //   .split(",");
          // let skuArr1 = this.editData.popCommentItemwaringList.skuList.map((i) => i.skuId);
          // this.goodsStateLength = this.unique(skuArr1, skuArr).length;
        }
        if (this.venderType) {
          this.selectGoodsSkuList  = this.editData.popCommentItemwaringList.skuList
          // arrList = this.editData.popCommentItemwaringList.skuList.map((i) => {
          //   return {
          //     ...i,
          //     wareTitle: i.itemTitle || i.title || i.goodTxt,
          //     logo: i.images || i.logo || i.imgSrc,
          //     isAdd: true,
          //     // wareId: Number(i.wareId),
          //     skuId: i.skuId,
          //   };
          // });
          this.goodsStateLength = this.editData.popCommentItemwaringList.skuList.length;
        }
        this.form.goodsList = [...arrList, ...this.selectGoodsSkuList];
        this.selectGoodsArr = arrList;
        if (this.editData.itemFilterType == 3) {
          this.returnSelectGoodsAppoint = arrList;
        } else if (this.editData.itemFilterType == 2) {
          this.returnSelectGoodsExclude = arrList;
        }
        this.goodsStateLength = this.selectGoodsSkuList.length + this.selectGoodsArr.length
        console.log(this.selectGoodsSkuList, 55555);
      }
    },
    keepOpen(state) {
      if (this.form.persistentOpenFlag == 0) {
        if (this.form.taskAllowRunStartTime == null || this.form.taskAllowRunEndTime == null) {
          this.$message.error("指定时间不能为空");
          return;
        }
      }
      if (this.form.startSendtimeConfig == null || this.form.endSendtimeConfig == null) {
        this.$message.error("通知时间不能为空");
        return;
      }
      state ? (this.form.isOpen = 1) : (this.form.isOpen = 2);
      state ? (this.disBtn1 = true) : (this.disBtn2 = true);
      let params = JSON.parse(JSON.stringify(this.form));
      console.log(params.goodsList)
      params.goodsList = params.goodsList.map((res) => {
        // return {
        //   goodID: item.wareId,
        //   goodMon: item.jdPrice,
        //   goodTxt: item.wareTitle,
        //   imgSrc: item.logo,
        //   skuId: item.skuId,
        // };
        let obj = {
          goodMon: res.jdPrice || res.price,
          goodID: res.wareId,
          imgSrc: res.logo || res.images || res.wareLogo,
          goodTxt: res.wareTitle || res.itemTitle || res.skuName || res.title,
          skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
        };
        if (this.venderType) {
          obj.skuId = res.skuId;
        }
        return obj;
      });
      delete params.popCommentItemwaringList;
      // params.startSendtimeConfig = this.dateParam(params.startSendtimeConfig);
      // params.endSendtimeConfig = this.dateParam(params.endSendtimeConfig);
      postTask(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("保存成功");
            this.$emit("close", true);
          } else {
            this.$message.error(res.message);
          }
          this.disBtn1 = false;
          this.disBtn2 = false;
        })
        .catch((err) => {
          this.disBtn1 = false;
          this.disBtn2 = false;
        });
    },
    pickerOptions1(val) {
      if (val != null && this.form.endSendtimeConfig && this.form.startSendtimeConfig) {
        let endDateVal = this.form.endSendtimeConfig.split(":");
        let startDateVal = this.form.startSendtimeConfig.split(":");
        // console.log(endDateVal,startDateVal)
        if (endDateVal && startDateVal) {
          if (startDateVal[0] > endDateVal[0]) {
            this.$message({
              message: "结束时间不能少于开始时间",
              type: "warning",
            });
            this.form.endSendtimeConfig = "";
            return;
          }
          if (startDateVal[1] >= endDateVal[1]) {
            this.$message({
              message: "结束时间不能少于开始时间",
              type: "warning",
            });
            this.form.endSendtimeConfig = "";
          }
        }
      }
    },
    handleClose() {
      this.$emit("close", false);
    },
    closeSend() {
      this.sendSmsTestState = false;
    },
    /**
     * 清除任务时间
     */
    clearTaskTime() {
      this.form.taskAllowRunStartTime = null;
      this.form.taskAllowRunEndTime = null;
    },
    selectGoodsChangeRaido(item) {
      // console.log(this.selectGoodsArr, 11111);
      // this.returnSelectGoodsAppoint = [];
      // this.returnSelectGoodsExclude = [];
      // this.selectGoodsSkuList = [];
      // this.form.goodsList = [];
      // this.goodsStateLength = 0;
    },
    // 选择商品选项切换
    selectGoodsChange(val) {
      // console.log(val, 2222);
      // this.form.goodsList = [];
      // this.selectGoodsArr = [];
      // console.log(this.selectGoodsSkuList, 666);
      if (val == 3) {
        this.selectGoodsState = true;
        // this.selectGoodsArr = this.returnSelectGoodsAppoint;
        this.form.goodsList = [...this.selectGoodsArr, ...this.selectGoodsSkuList];
      } else if (val == 2) {
        // this.selectGoodsArr = this.returnSelectGoodsExclude;
        this.selectGoodsState = true;
        this.form.goodsList = [...this.selectGoodsArr, ...this.selectGoodsSkuList];
      } else {
        this.form.goodsList = [];
      }
    },
    // 选择商品数据接收
    selectGoodsClose(data, item) {
      // console.log(data);
      if (!data && !item) {
        this.selectGoodsState = false;
        return;
      }
      let goodsList = data.map((res) => {
        // return {
        //   goodID: item.wareId,
        //   goodMon: item.jdPrice,
        //   goodTxt: item.wareTitle,
        //   imgSrc: item.logo,
        //   skuId: item.skuId,
        // };
        let obj = {
          ...res,
          goodMon: res.jdPrice || res.price,
          goodID: res.wareId,
          imgSrc: res.logo || res.images || res.wareLogo,
          goodTxt: res.wareTitle || res.itemTitle,
          skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
        };
        if (this.venderType) {
          obj.skuId = res.skuId;
        }
        return obj;
      });
      this.selectGoodsArr = data;
      // console.log(this.selectGoodsArr);
      if (this.form.itemFilterType == 3) {
        this.returnSelectGoodsAppoint = data;
      } else {
        this.returnSelectGoodsExclude = data;
      }
      this.form.goodsList = goodsList;
      if (!this.venderType) {
        let skuArr = [];
        data.forEach((i) => {
          if (i.skuList != 0) {
            i.skuList.forEach((ele) => {
              if (ele.skuId) {
                skuArr.push(ele.skuId);
              } else {
                skuArr.push(ele);
              }
            });
          }
        });
        let skuArr1 = item.map((i) => i.skuId);
        this.goodsStateLength = this.unique(skuArr, skuArr1).length;
        this.selectGoodsSkuList = item;
        this.form.goodsList = [...goodsList, ...this.selectGoodsSkuList];
      }
      if(item == undefined){
        this.goodsStateLength = data.length
        this.selectGoodsSkuList = data
        this.form.goodsList = [];
        this.form.goodsList = [...data];
  
      }else{
        this.goodsStateLength = data.length + item.length
        this.selectGoodsArr = data
        this.selectGoodsSkuList = item
        this.form.goodsList = [];
        this.form.goodsList = [...goodsList,...item];
      }
      this.selectGoodsState = false;
    },
    // 短信测试发送号码变化监听
    sendMobileChange() {
      const { mobile } = this.form;
      this.form.mobile = mobile && mobile.replace("，", ",");
    },
    // 点击发送短信测试
    sendSmsTest() {
      const { content } = this.form;
      if (!content || !content.trim()) {
        this.$message.warning("请输入短信内容 !");
        return;
      }
      if (!this.form.mobile) {
        this.$message.warning("请先输入发送号码 !");
        return;
      }
      this.sendSmsTestState = true;
    },
    // 发送短信-预提交
    handleSendConfirm() {
      const params = {
        mobiles: this.form.mobile,
        sendType: 0,
        dataFrom: 0,
        checkInvalidChar: false,
      };
      this.disSendBtn = true;
      // preCommit(params).then((res) => {
      let postData = {
        content: this.form.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: params.mobiles,
        checkInvalidChar:false,
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          this.$message.success(res.data)
          this.sendSmsTestState = false;
        }
      //   res && this.sendSms(res.data.sendObjectId);
      });
    },
    // 发送短信-正式
    sendSms(id) {
      const params = {
        sendObjectId: id,
        blackFlag: false,
        smsSuffix: "【云起科技】",
        content: this.form.content,
        smsType: 0
      };
      platformSend(params)
        .then((res) => {
          this.disSendBtn = false;
          if (res.code == 1) {
            this.$message.success("发送成功!");
          } else {
            this.$message.warning(res.message);
          }
          this.sendSmsTestState = false;
        })
        .catch((err) => {
          this.disSendBtn = false;
        });
    },
    deepCopy(obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
    unique(arr, arr1) {
      let list = arr.filter((item) => item);
      let listArr = list.map((item) => Number(item));
      let list1 = arr1.filter((item) => item);
      let listArr1 = list1.map((item) => Number(item));
      console.log(listArr, listArr1);
      return [...new Set([...listArr, ...listArr1])];
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer {
  width: 894px !important;
}
/deep/ .timeChangeselect .el-icon-time:before {
  content: "\E71F";
  position: absolute;
  left: 190px;
}
.createTpl {
  display: flex;
  flex-direction: column;
  height: 100%;
  .head {
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 28px;
    height: 62px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    .close {
      cursor: pointer;
      color: #ccc;
    }
  }
  .createTplMain {
    flex: 1;
    box-sizing: border-box;
    padding: 16px 0 0 38px;
    .selectBtn {
      width: 126px;
      height: 32px;
      cursor: pointer;
      outline: none;
      border-radius: 3px;
      background-color: #fff4f4;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      &:hover {
        background: #fff4f4;
        border: 1px solid #fe4d45 !important;
        color: #fe4d45 !important;
      }
      &:active {
        background: #fff4f4;
        border: 1px solid #fe4d45 !important;
        color: #fe4d45;
      }
    }
    .ition {
      display: flex;
      align-items: center;
      margin-top: 12px;
      color: #606266;
      .itionIpt {
        margin-left: 10px;
      }
    }
    .adoptLine {
      margin-top: 12px;
      color: #606266;
    }
    .adoptRemark {
      display: flex;
      align-items: flex-start;
      margin-top: 12px;
      color: #606266;
      .remarkArea {
        margin-left: 12px;
      }
    }
    .disabled {
      background: rgba(246, 246, 246, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      color: #999;
      cursor: not-allowed;
    }
    .marleft {
      margin-left: 6px;
    }
    .sendMobile {
      display: flex;
      align-items: center;
      button {
        width: 110px;
        height: 32px;
        line-height: 28px;
        text-align: center;
        background-color: white;
        border: none;
        outline: none;
        cursor: pointer;
        border-radius: 3px;
        font-size: 14px;
        font-weight: 400;
        transition: all 0.2s;
      }
      .sendSmsTest {
        margin: 0 8px 0 12px;
        border: 1px solid #fe4d45;
        color: #fe4d45;
        &:hover {
          background-color: #fe4d45;
          color: #fff;
        }
      }
      .smsRecord {
        border: 1px solid #ccc;
        color: #999;
        &:hover {
          border: 1px solid #fe4d45;
          color: #fe4d45;
        }
      }
    }
  }
  .footBtn {
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 48px;
    height: 60px;
    line-height: 60px;
    border-top: 1px solid #f0f0f0;
    .keepOpenBtn,
    .keepBtn {
      width: 98px;
      height: 32px;
      font-size: 14px;
      font-weight: 400;
      outline: none;
      background-color: white;
      border: none;
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .keepOpenBtn {
      margin-right: 12px;
      color: #fff;
      background-color: #fe4d45;
      &:hover {
        opacity: 0.9;
      }
    }
    .keepBtn {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
  }
}
.sendSmsTestWrap {
  text-align: center;
  p {
    margin: 40px auto;
  }
}
</style>
